// Vuex module — Pengaturan Brand (P26_045 FR-01).
//
// Halaman /offline-stores/brand-settings. Endpointnya di routes/routes/unionweb.php grup
// `/brand-settings`, dijaga auth:api + access (modul `brandsetting_*`). Setiap tulis
// mengembalikan daftar terbaru, jadi halaman cukup menimpa state dengan jawabannya.
import $axios from "../../api";

const PREFIX = "unionweb/brand-settings";

const state = () => ({
  isLoading: false,
  brands: [],
  meta: {},
});

const mutations = {
  SET_LOADING(s, v) {
    s.isLoading = v;
  },
  SET_DATA(s, v) {
    s.brands = v?.brands || [];
    s.meta = v || {};
  },
};

const actions = {
  async getList({ commit, dispatch }) {
    commit("SET_LOADING", true);
    try {
      const res = await $axios.get(`${PREFIX}/list`);
      commit("SET_DATA", res.data?.data);
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response || { message: "Unknown error" }, { root: true });
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  // Penolakan 422 (AC-01.4) dilempar ke halaman supaya kalimatnya tampil di baris brand yang
  // salah, bukan ditelan. `errors` di badan jawaban berbentuk brand_id => kalimat.
  async save({ commit }, rows) {
    const res = await $axios.post(`${PREFIX}/save`, { rows });
    commit("SET_DATA", res.data?.data);
  },

  async toggle({ commit }, { brandId, isHomeBrand }) {
    const res = await $axios.post(`${PREFIX}/toggle`, { brand_id: brandId, is_home_brand: isHomeBrand });
    commit("SET_DATA", res.data?.data);
  },

  // Tidak menyentuh state: isi modal Riwayat hidup selama modalnya terbuka saja.
  async getHistory(_ctx, brandId) {
    const res = await $axios.get(`${PREFIX}/history`, { params: { brand_id: brandId } });

    return res.data?.data?.history || [];
  },

  // Sama: milik satu modal. Dipaginasi di SERVER — satu brand bisa punya ratusan kode barang,
  // berbeda dari daftar brand induknya yang muat dalam satu payload.
  async getItems(_ctx, { brandId, q = "", page = 1, view = 25 }) {
    const res = await $axios.get(`${PREFIX}/items`, {
      params: { brand_id: brandId, q, page, view },
    });

    return res.data?.data || { items: [], total: 0 };
  },
};

export default { namespaced: true, state, mutations, actions };
